import { BaseSyntheticEvent, FC, useMemo } from "react";
import { FormFieldType } from "../../constants";
import { CommonInput, INPUT_TYPES, Colors, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import EditIcon from "shared/icons/EditIcon";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

export const Container = styled.div`
  position: relative;
`

const Button = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 44px;
    padding: 6px 16px;
    font-size: 11px;
    line-height: 13px;
    color: ${Colors.geoWhite100};
    border: 1px solid ${Colors.geoWhite100};
    border-radius: 3px;
    cursor: pointer;
`;

export const EditMobileIcon = styled(EditIcon)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 44px;
`;

export const ModalInput: FC<{ 
    type: FormFieldType, 
    index: number,
    onChange: (index: number, ev: BaseSyntheticEvent, lang?: string) => void, 
    onToggleModalClick: (index: number) => void,
    value: string,
    options: any[] }> = ({ type, index, onChange, value, options, onToggleModalClick }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.m_1024);
    const { t } = useTranslation();

    const label = useMemo(() => {
        if (isMobile) {
            return t('teams.adminPage.fields.form_field_type')
        }
        return undefined
    }, [options, type])

    const modalButton = (
        isMobile ? <EditMobileIcon onClick={() => onToggleModalClick(index)} /> : <Button onClick={() => onToggleModalClick(index)}>Настроить</Button>
    )

    if (type === FormFieldType.SelectOne || type === FormFieldType.SelectMultiple) {
        return (
            <Container>
                <CommonInput
                    type={INPUT_TYPES.dropdown}
                    name={'type'}
                    value={value}
                    {...(!isMobile && { label })}
                    options={options as any}
                    onChange={({value}: any) => {
            
                        const fakeEvent = { target: { value: value, name: 'type' }} as BaseSyntheticEvent
                        onChange(index, fakeEvent)
                    }}
                />
                {modalButton}
            </Container>
        )
    }


   return (
    <CommonInput
    type={INPUT_TYPES.dropdown}
    name={'type'}
    {...(!isMobile && { label })}
    value={value}
    options={options as any}
    onChange={({value}: any) => {

      const fakeEvent = { target: { value: value, name: 'type' }} as BaseSyntheticEvent
      onChange(index, fakeEvent)
    }}
  />
   )
}       import { BaseSyntheticEvent, FC, useMemo } from "react";
import { FormFieldType } from "../../constants";
import { CommonInput, INPUT_TYPES, Colors, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import EditIcon from "shared/icons/EditIcon";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

export const Container = styled.div`
  position: relative;
`

const Button = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 44px;
    padding: 6px 16px;
    font-size: 11px;
    line-height: 13px;
    color: ${Colors.geoWhite100};
    border: 1px solid ${Colors.geoWhite100};
    border-radius: 3px;
    cursor: pointer;
`;

export const EditMobileIcon = styled(EditIcon)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 44px;
`;

export const ModalInput: FC<{ 
    type: FormFieldType, 
    index: number,
    onChange: (index: number, ev: BaseSyntheticEvent, lang?: string) => void, 
    onToggleModalClick: (index: number) => void,
    value: string,
    options: any[] }> = ({ type, index, onChange, value, options, onToggleModalClick }) => {
    const isMobile = useBreakpoint(LayoutConst.screen.m_1024);
    const { t } = useTranslation();

    const label = useMemo(() => {
        if (isMobile) {
            return t('teams.adminPage.fields.form_field_type')
        }
        return undefined
    }, [options, type])

    const modalButton = (
        isMobile ? <EditMobileIcon onClick={() => onToggleModalClick(index)} /> : <Button onClick={() => onToggleModalClick(index)}>Настроить</Button>
    )

    if (type === FormFieldType.SelectOne || type === FormFieldType.SelectMultiple) {
        return (
            <Container>
                <CommonInput
                    type={INPUT_TYPES.dropdown}
                    name={'type'}
                    value={value}
                    {...(!isMobile && { label })}
                    options={options as any}
                    onChange={({value}: any) => {
            
                        const fakeEvent = { target: { value: value, name: 'type' }} as BaseSyntheticEvent
                        onChange(index, fakeEvent)
                    }}
                />
                {modalButton}
            </Container>
        )
    }


   return (
    <CommonInput
    type={INPUT_TYPES.dropdown}
    name={'type'}
    {...(!isMobile && { label })}
    value={value}
    options={options as any}
    onChange={({value}: any) => {

      const fakeEvent = { target: { value: value, name: 'type' }} as BaseSyntheticEvent
      onChange(index, fakeEvent)
    }}
  />
   )
}       